import React, { Component } from 'react';
import '../privacy/PrivacyTerms.css';

class ChildSafetyStandards extends Component {
  render() {
    return (
      <div className="PrivacyTerms">
        <div className="contents">
          <h1 style={{alignSelf:"center", fontFamily:"NanumBarunGothicBold"}}>아동 안전 표준</h1><br/>
          <span>
            레몬케이크(이하 “회사”)가 제공하는 독서 소셜 커뮤니티 “자정의 도서관”(이하 “서비스”)은
            아동의 안전을 최우선으로 하며, 아동 성적 학대 및 착취(Child Sexual Abuse and Exploitation,
            이하 “CSAE”)와 아동 성적 학대 콘텐츠(Child Sexual Abuse Material, 이하 “CSAM”)를 엄격히
            금지합니다.
          </span>
          <br/>

          <span className="first">제1조 (무관용 원칙)</span><br/>
          <span className="second">
            회사는 서비스에서 발생하는 모든 형태의 CSAE 및 CSAM에 대해 무관용 원칙을 적용합니다.
            실제 아동뿐 아니라 아동을 묘사한 합성·가공·생성 콘텐츠도 관련 법령에서 금지되는 범위에
            포함하여 처리합니다.
          </span>
          <br/><br/>

          <span className="first">제2조 (금지되는 행위 및 콘텐츠)</span><br/>
          <span className="second">서비스에서는 다음 행위와 콘텐츠를 허용하지 않습니다.</span>
          <ul>
            <li className="third">CSAM의 제작, 게시, 저장, 공유, 전송 또는 유포</li>
            <li className="third">아동을 성적으로 착취·학대하거나 위험에 빠뜨리는 콘텐츠 및 행위</li>
            <li className="third">성적 목적의 아동 유인, 그루밍, 성착취 목적의 협박 또는 금품 요구</li>
            <li className="third">아동 대상 성매매·인신매매를 조장하거나 알선하는 행위</li>
            <li className="third">아동에게 성적인 대화, 이미지 또는 만남을 요구하는 행위</li>
          </ul>
          <br/>

          <span className="first">제3조 (신고 방법)</span><br/>
          <span className="second">
            사용자는 자정의 도서관 앱에서 게시물, 리뷰, 댓글, 프로필 및 채팅의 신고 기능을 이용하여
            아동 안전 관련 우려사항을 신고할 수 있습니다. 앱 내 신고가 어려운 경우 아래 이메일로
            신고할 수 있습니다.
          </span>
          <ul>
            <li className="third">아동 안전 담당 이메일: help.lemoncake@gmail.com</li>
          </ul>
          <br/>

          <span className="first">제4조 (신고 검토 및 조치)</span><br/>
          <span className="second">
            회사는 신고 또는 기타 방법으로 CSAE나 CSAM을 인지한 경우 해당 내용을 검토하고, 관련
            콘텐츠의 노출 제한 또는 삭제, 계정의 이용 제한·정지·해지 등 필요한 조치를 취합니다.
            긴급하거나 중대한 사안은 우선적으로 처리합니다.
          </span>
          <br/><br/>

          <span className="first">제5조 (법률 준수 및 관계기관 신고)</span><br/>
          <span className="second">
            회사는 적용되는 아동 안전 관련 법률과 규정을 준수합니다. CSAM이 확인된 경우 관련 법령과
            절차에 따라 경찰청 등 관할기관에 신고하고, 필요한 경우 미국 실종학대아동방지센터(NCMEC)를
            포함한 관련 기관의 조사와 적법한 요청에 협조합니다.
          </span>
          <br/><br/>

          <span className="first">제6조 (아동 안전 담당 연락처)</span><br/>
          <span className="second">
            아동 안전 정책, 신고 처리 및 집행 절차에 관한 문의는 아래 담당 연락처로 접수할 수 있습니다.
          </span>
          <ul>
            <li className="third">운영 주체: 레몬케이크</li>
            <li className="third">서비스명: 자정의 도서관</li>
            <li className="third">담당자: 최유진 대표</li>
            <li className="third">이메일: help.lemoncake@gmail.com</li>
            <li className="third">전화번호: 070-8098-9642</li>
          </ul>
          <br/>

          <span className="first">부칙</span><br/>
          <span className="second">본 아동 안전 표준은 2026년 8월 29일부터 적용됩니다.</span>
        </div>
      </div>
    );
  }
}

export default ChildSafetyStandards;
